import React from "react"
import AppDialog from "../../../components/Common/AppDialog"

import '../order.css';

const DeleteOrder = (props) => {

    return (
        <AppDialog
            open={props.open}
            close={() => props.close()}
            title={'Delete order'}
            titleIcon={'error'}
            positiveTitle={'Delete order'}
            positivePress={() => props.submit()}
            positiveButtonStyle={{ backgroundColor: '#44d62c', color: 'white', border: '1px solid #44d62c' }}
            negativePress={() => props.close()}
            negativeTitle={'Cancel'}
            width={'30%'}
        >
            <div className="">
                Are you sure you want to delete this order?
            </div>
        </AppDialog>
    )
}

export default DeleteOrder;